import { AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

/**
 * Inserts a visually hidden native <caption> into a PrimeNG p-table.
 * PrimeNG's pTemplate="caption" renders a div outside the <table>,
 * so it is not exposed as a table caption (WCAG 1.3.1).
 *
 * Usage: <p-table [appTableCaption]="'some.key' | translate" ...>
 */
@Directive({
  selector: '[appTableCaption]'
})
export class TableCaptionDirective implements AfterViewInit, OnChanges {

  @Input('appTableCaption') captionText: string;

  private caption: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    const table: HTMLTableElement = this.el.nativeElement.querySelector('table');
    if (!table) {
      return;
    }
    this.caption = this.renderer.createElement('caption');
    this.renderer.addClass(this.caption, 'sr-only');
    this.renderer.insertBefore(table, this.caption, table.firstChild);
    this.setText();
  }

  ngOnChanges(): void {
    this.setText();
  }

  private setText(): void {
    if (this.caption) {
      this.renderer.setProperty(this.caption, 'textContent', this.captionText || '');
    }
  }
}
